import createjs from 'createjs-npm';
import { App } from './base';

export class Loading {
    protected options: any;

    protected constructor(options: any) {
      this.options = options;
      this.init();
    }

    protected init() {
      // this.initStage();
    }

    protected startAnimation(stage: any) {
      createjs.Ticker.setFPS(24);
      createjs.Ticker.addEventListener('tick', stage);
      stage.enableMouseOver();
    }

    protected makeResponsive(isResp: any, respDim: any, isScale: any, scaleType: any, opts: any, stage: any) {
      let lastW: any;
      let lastH: any;
      let lastS: number = 1;
      const canvas: any = document.getElementById(opts.canvas);
      // const animContainer: any = document.getElementById(opts.container);
      // const domOverlayContainer: any = document.getElementById(opts.overlay);
      // resize
      (window as any).addEventListener('resize', resizeCanvas);
      resizeCanvas();
      function resizeCanvas(): void {
        const w: any = App.properties.width;
        const h: any = App.properties.height;
        const iw: any = window.innerWidth;
        const ih: any = window.innerHeight;
        const pRatio: any = window.devicePixelRatio || 1;
        const xRatio: any = iw / w;
        const yRatio: any = ih / h;
        let sRatio: any = 1;
        if (isResp) {
          if ((respDim === 'width' && lastW === iw) || (respDim === 'height' && lastH === ih)) {
            sRatio = lastS;
          } else if (!isScale) {
            if (iw < w || ih < h) {
              sRatio = Math.min(xRatio, yRatio);
            }
          } else if (scaleType === 1) {
            sRatio = Math.min(xRatio, yRatio);
          } else if (scaleType === 2) {
            sRatio = Math.max(xRatio, yRatio);
          }
        }
        canvas.width = w * pRatio * sRatio;
        canvas.height = h * pRatio * sRatio;
        // tslint:disable-next-line: whitespace
        canvas.style.width = `${w * sRatio}px`;
        canvas.style.height = `${h * sRatio}px`;
        stage.scaleX = pRatio * sRatio;
        stage.scaleY = pRatio * sRatio;
        lastW = iw; lastH = ih; lastS = sRatio;
        stage.tickOnUpdate = false;
        stage.update();
        stage.tickOnUpdate = true;
      }
    }

    protected initStage() {

    }
}
